import {VerificationCreateParams} from "./model/verification-create-params";
import {VerificationChallengeSubmitParams, ChallengeNonceParams} from "./model/verification-challenge-submit-params";
import {HoneypotFieldParams} from "./model/honeypot-field-params";
import {Config} from "../../config";

export class ApiService {

  public static async createVerification(config: Config, body: VerificationCreateParams, signal?: AbortSignal): Promise<Response> {

    const url = `${config.apiUrl}/v2/verifications`;

    return await this.post(url, body, signal);
  }

  public static async submitChallenge(config: Config, verificationId: string, startSolvingTimestamp: string, solvedTimestamp: string, tasks: ChallengeNonceParams[], honeypotFields: HoneypotFieldParams[], userEvents: any[], signal?: AbortSignal): Promise<Response> {

    const url = `${config.apiUrl}/v2/verifications/${verificationId}/challenges`;
    const body: VerificationChallengeSubmitParams = { startSolvingTimestamp, solvedTimestamp, tasks, honeypotFields, userEvents };

    return await this.post(url, body, signal);
  }

  private static async post(url = '', body: any = {}, signal?: AbortSignal): Promise<Response> {

    return await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(body),
      signal,
    });
  }
}
